// src/lib/loften.js — SPEGEL av löftestexterna i lib/kundmeningar.js (LOFTEN, ANSVARSGRANS, UNDERLAGET).
// Frontend importerar aldrig backendens ESM-moduler direkt; KM-07 kräver att texterna är identiska,
// så ett löfte eller en ansvarsgräns kan inte formuleras på ett sätt i mejlet och ett annat på sidan.
export const LOFTEN_TEXT = {
  bytesunderlag: 'Vi tar fram ett besparingsunderlag: jämförelsen mot verifierat listpris och färdiga utkast till uppsägning och nyteckning, som ni själva skickar till leverantörerna.',
  vidarebefordran: 'Vidarebefordra leverantörsfakturor till faktura@inbox.arvoflow.se — vi analyserar dem och svarar med resultatet.',
  inkorgskoppling: 'Kopplingen räknar i dag hur många fakturamejl ni har. Analysen gör vi på de fakturor ni laddar upp eller vidarebefordrar.',
  personligtSvar: 'En av grundarna hör av sig till er.',
  egenAdress: 'Allt som kommer till er adress hamnar i det här rummet och analyseras — vem som än skickar det.',
  gmailKod: 'När Gmail skickar sin bekräftelsekod till er adress visar vi den här, så slipper ni leta efter den.',
  kvittoTill: 'Kvitton och svar på det som kommer hit går till',
  kvittoIngen: 'Den här adressen är inte knuten till någon e-post, så inga kvitton skickas härifrån. Fakturorna hamnar ändå här i rummet.',
  intelligenceAnmalan: 'Vi har tagit emot er anmälan till Arvo Intelligence. En av grundarna hör av sig för att starta abonnemanget — bevakningen slås på först då.',
  premiumutskick: 'Med Arvo Intelligence mejlar vi månadsbriefen och prislarmen för era leverantörer.',
  gratisanalys: 'Utan abonnemang analyserar vi de fakturor ni laddar upp eller vidarebefordrar och svarar på dem. Utöver de avtalspåminnelser ni själva beställer skickar vi inga utskick däremellan.',
};

/** Enheten för varje kohorttal — speglar KOHORT_ENHET (KM-07). Talen räknar avsändare, aldrig bolag. */
export const KOHORT_ENHET = 'avsändare';

export const ANSVARSGRANS_TEXT = {
  inteOmbud: 'Arvo säger inte upp, tecknar eller ändrar några avtal åt er, och beställningen ger oss ingen fullmakt att göra det.',
  niAgerar: 'Uppsägning och nyteckning gör ni själva, direkt med leverantörerna — när och om ni vill.',
  inteAvtal: 'Underlaget är en analys med färdiga utkast, inte ett avtal. Inget händer med era avtal förrän ni själva agerar, och ångrar ni beställningen behöver ni inte göra något.',
  arvode: 'Genomför ni bytet utgår ett arvode om 20 % av första årets besparing, som en engångsavgift tre månader efter att det nya avtalet aktiverats. Genomför ni det inte kostar underlaget ingenting.',
};

export const PROSPEKT_TEXT = {
  ankareRubrik: 'Verifierat publikt listpris — det lägsta vi kan belägga',
  ingenKostnad: 'Vad ni själva betalar ser vi först i en faktura. Därför räknar vi ingen besparing åt er här.',
  nivaOkand: 'Vilken nivå ni har vet vi inte — priset gäller den namngivna produkten.',
  cta: 'Se vad ni betalar mot listpris',
};

export const UNDERLAGET_TEXT = {
  cta: 'Beställ besparingsunderlaget',
  skicka: 'Beställ underlaget',
  mottagen: 'Vi har tagit emot er beställning av ett besparingsunderlag.',
  mottagenAvveckling: 'Vi har tagit emot er beställning av ett underlag för avvecklingen.',
};
